import React, { useMemo, useState } from "react";
import { useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import {
  academicCardInfoLabels,
  detailsRowStyles,
} from "../constant/student-details";
import CustomChip from "./CustomChip";
import StudentPhoto from "./studentPhoto";
import ApplicationIdList from "./ApplicationIdList";
import QuickActions from "./QuickActions";
import CustomLoader from "../../common/commonComponents/Loader/loader";
import {
  fetchAllPostPromisedData,
  fetchAllPromisedData,
} from "../../common/utils/methods/commonMethods/utilityMethod";
import { endpoint } from "../../common/constant";
import UploadAttachments from "views/pages/manage/edpOps/stockManagement/stockConsumption/form/UploadAttachments";
import { openFileInNewWindow } from "../../academicPlanAndTest/academicTimetable/lectureModule/LectureListItem";
import CustomTooltip from "../../common/customTooltip/CustomTooltip";
import moment from "moment";
import { FaUpload } from "react-icons/fa";
import { FaRegEye } from "react-icons/fa";
import { failureToast } from "services/http";
import ALoader from "views/pages/manage/common/a-loader";
import ProgramActionUpdate from "./programActionUpdate";
import FormManagement from "./formManagement";
import { useFetchCourseIdDetail, useFetchProgramHistory } from "./programActionUpdate/hook";
import { getProgramActionViewIcon } from "./programActionUpdate/hook";
const AcademicDetailsCard = ({
  activeTab,
  psid,
  studentApplicationDetails,
  studentDetails,
  setApiLoader = () => {},
  loader,
  photoKey,
  fetchApplications = () => {},
  fetchStudentDetails = () => {},
  setCurrentApplicationDetails,
  fetchData,
  updateProgramActionPermissions,
}) => {
  const [currIndex, setCurrIndex] = useState(0);
  const [ApiLoader, setLoader] = useState(false);
  const [activeApplicationDetails, setActiveApplicationDetails] = useState(
    studentApplicationDetails?.[currIndex]
  );
    const programActionHistory = useFetchProgramHistory(activeApplicationDetails?.applicationId);
    const courseIdDetail = useFetchCourseIdDetail(activeApplicationDetails);

  const saveHandler = (e, applicationId) => {
    const { key } = e;
    if (!key) {
      failureToast("Please upload file again!");
    }
    updateStudentDetailsApi({ marksheetAndAdmissionKey: key }, applicationId);
  };

  const onApplicationChange = (id, parentAppId = "") => {
    const selectedApplication = studentApplicationDetails.findIndex(
      (obj) => obj.applicationId === id
    );

    if (id.includes("-")) {
      const parentApplication = studentApplicationDetails.findIndex(
        (obj) => obj.applicationId === parentAppId
      );
      setCurrIndex(parentApplication);
    } else setCurrIndex(selectedApplication);

    setCurrentApplicationDetails(
      studentApplicationDetails[selectedApplication]
    );
    setActiveApplicationDetails(studentApplicationDetails[selectedApplication]);
  };

  const getModificationCount = async (appId) => {
    try {
      const count = await fetchAllPromisedData(
        `${endpoint?.otherCharges?.modificationCount}/${appId}`
      );
      setActiveApplicationDetails((prev) => ({ ...prev, modifyCount: count }));
    } catch (err) {
      console.log(err);
    }
  };

  const getParentConsentDetails = async (quotationId) => {
    try {
      const resp = await fetchAllPromisedData(
        `${endpoint.parentConsent.getConsentDetails}/${quotationId}`,
        true
      );
      if (resp?.code === 200) {
        setActiveApplicationDetails((prev) => ({
          ...prev,
          parentConsentDetails: resp?.data,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const updateStudentDetailsApi = (request, applicationId) => {
    if (!applicationId) return false;
    try {
      setApiLoader(true);
      const response = fetchAllPostPromisedData(
        `${endpoint.studentDetails.updateStudentApplicationDetails}/${applicationId}`,
        request,
        "put"
      );
      fetchApplications();
      setApiLoader(false);
    } catch (error) {
      setApiLoader(false);
    }
  };

  useEffect(() => {
    setActiveApplicationDetails(studentApplicationDetails?.[currIndex]);
    studentApplicationDetails?.[currIndex]?.applicationId &&
      getModificationCount(
        studentApplicationDetails?.[currIndex]?.applicationId
      );
    studentApplicationDetails?.[currIndex]?.applicationQuotationDetailsId &&
      getParentConsentDetails(
        studentApplicationDetails?.[currIndex]?.applicationQuotationDetailsId
      );
  }, [currIndex, studentApplicationDetails]);
  const academicLabels = useMemo(() => {
  return academicCardInfoLabels(true, programActionHistory,courseIdDetail);
}, [programActionHistory,courseIdDetail]);

  return (
    <Card>
      <CardBody>
        <h3 className="mb-2" style={{ fontSize: "20px" }}>
          Academic details
        </h3>
        {loader ? (
          <CustomLoader />
        ) : (
          <div>
            <div>
              <div
                style={{ gap: "20px" }}
                className="mb-3 d-flex  align-items-start"
              >
                <div>
                  <StudentPhoto
                    photoKey={photoKey}
                    fetchApplications={fetchApplications}
                    psid={psid}
                  />
                </div>
                <div>
                  <h3 style={{ fontSize: "28px" }}>
                    {activeApplicationDetails?.studentName}
                  </h3>
                  <CustomChip
                    bgColor="#EDF7F2"
                    textColor="#0B442D"
                    text={`PSID: ${psid}`}
                    style={{ fontSize: "14px" }}
                  />
                </div>
              </div>
              <div className="mb-4">
                {ApiLoader && <ALoader />}
                <ApplicationIdList
                  studentApplicationDetails={studentApplicationDetails}
                  currIndex={currIndex}
                  setCurrIndex={setCurrIndex}
                  onApplicationChange={onApplicationChange}
                />

                
                  {academicLabels?.map((infoRow) => {

                    const key = infoRow["objKey"];
                    // const isShowToolTip = infoRow["isShowToolTip"] || false;
                    const value = infoRow?.valueGetter

                      ? infoRow?.valueGetter(activeApplicationDetails)
                      : (activeApplicationDetails?.[key] ?? "")
                        .toString()
                        .trim() ||
                      (activeApplicationDetails?.[key] === 0 ? "0" : "-");


                    const RightComponent = infoRow?.renderRight
                      ? infoRow.renderRight(value, activeApplicationDetails)
                      : null;


                    return (
                      <Row style={detailsRowStyles} key={key}>
                        <Col sm="6">{infoRow["title"]}</Col>
                        <Col sm="6" style={{ fontWeight: 600 }}>
                          <div className="d-flex gap-md">{value}  {RightComponent}</div>
                        </Col>
                      </Row>
                    );
                  })}
                </div>

              <FormManagement
                admissionFormSaveHandler={saveHandler}
                activeApplicationDetails={activeApplicationDetails}
              />
              <QuickActions
                activeTab={activeTab}
                fetchStudentDetails={fetchStudentDetails}
                fetchApplications={fetchApplications}
                studentDetails={studentDetails}
                setApiLoader={setApiLoader}
                activeApplicationDetails={activeApplicationDetails}
              />
              <ProgramActionUpdate
                programAction={activeApplicationDetails?.programActions}
                applicationId={activeApplicationDetails?.applicationId}
                studentDetails={activeApplicationDetails}
                fetchData={fetchData}
                programActionHistory={programActionHistory}
                updateProgramActionPermissions={updateProgramActionPermissions}
              />
            </div>
          </div>
        )}
      </CardBody>
    </Card>
  );
};

export default AcademicDetailsCard;
